import { useState } from "react";
import "./styles/HomeNew.css";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="nav">
      {/* Logo */}
      <a className="nav__logo" href="/">
        <img src="/images/homePage/Logo.jpg" alt="FBT Logo" width="36" height="36" className="nav__logo-img" />
        <span>FBT</span>
      </a>

      {/* Desktop links */}
      <div className="nav__links nav__links--desktop">
        <a href="/" id="navHome">Home</a>
        <a href="/about" id="navAbout">About Us</a>
        <a href="/projects" id="navProjects">Projects</a>
        <a href="/kitefest" id="navKiteFest">Kite Fest</a>
        <a href="/yicu" id="navYICU">YICU</a>
        <a href="/ygc" id="navYGC">YGC</a>
        <a href="/steam" id="navSTEAM">STEAM</a>
        <a href="/yvc" id="navYVC">YVC</a>
        <a href="/5k" id="nav5K">5K/2K</a>
        <a href="/grant" id="navGrant">Grant</a>
        <a href="/contact" id="navContact">Contact Us</a>
        <a href="/donate" className="nav__donate">Donate</a>
      </div>

      {/* Mobile hamburger */}
      <button
        className="nav__hamburger"
        onClick={() => setOpen((v) => !v)}
        aria-label="Toggle navigation"
        aria-expanded={open}
      >
        <span className={`nav__bar ${open ? "nav__bar--open" : ""}`} />
        <span className={`nav__bar ${open ? "nav__bar--open" : ""}`} />
        <span className={`nav__bar ${open ? "nav__bar--open" : ""}`} />
      </button>

      {/* Mobile drawer */}
      {open && (
        <div className="nav__drawer">
          <a href="/" onClick={() => setOpen(false)}>Home</a>
          <a href="/about" onClick={() => setOpen(false)}>About Us</a>
          <a href="/projects" onClick={() => setOpen(false)}>Projects</a>
          <a href="/kitefest" onClick={() => setOpen(false)}>Kite Fest</a>
          <a href="/yicu" onClick={() => setOpen(false)}>YICU</a>
          <a href="/ygc" onClick={() => setOpen(false)}>YGC</a>
          <a href="/steam" onClick={() => setOpen(false)}>STEAM</a>
          <a href="/yvc" onClick={() => setOpen(false)}>YVC</a>
          <a href="/5k" onClick={() => setOpen(false)}>5K/2K</a>
          <a href="/grant" onClick={() => setOpen(false)}>Grant</a>
          <a href="/contact" onClick={() => setOpen(false)}>Contact Us</a>
          <a href="/donate" className="nav__donate nav__donate--drawer">Donate</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;